import React from "react";

function Colors_Analogous() {
  return (
    <div>
      <h1>Colors_Analogous Component</h1>
      <p>This is the Colors Analogous tutorial page content.</p>
    </div>
  );
}

export default Colors_Analogous;
